module.exports = __webpack_public_path__ + "img/accessory_base.9d6d330b.svg";